module.exports = __webpack_public_path__ + "img/img-99.df254e3f.png";